module.exports = __webpack_public_path__ + "static/media/file-certificate.f222098c.svg";